<template>
  <div>
    <div class="hint">
      <img :src="public_path + '/static/images/success_icon@3x.png'" alt="">
      <span>订单提交成功，请尽快支付</span>
    </div>
    <div class="orderid">订单编号：{{payOrder.order_no}}</div>
    <div class="money">
      <div class="text">支付金额</div>
      <div class="sum">￥<span>{{payOrder.amount}}</span></div>
    </div>
    <div class="way">
      <div class="title">选择支付方式</div>
      <div class="channel">
        <div v-if="iswx" class="name">
          <img :src="public_path + '/static/images/wechat_icon@3x.png'" alt="">
          <span>微信支付</span>
        </div>
        <div v-if="!iswx" class="name">
          <img :src="public_path + '/static/images/alipay_icon@3x.png'" alt="">
          <span>支付宝支付</span>
        </div>
        <div class="sel-img" >
          <img :src="public_path + '/static/images/success_icon@3x.png'" alt="">
        </div>
      </div>
      <button class="pay-btn" @click="pay">确认支付￥{{payOrder.amount}}</button>
      <button class="cancel-btn" @click="showDislog">取消订单</button>
    </div>
    <div class="bg" v-if="dialog">
      <div class="dialog">
        <div class="content">是否取消订单</div>
        <div class="btn">
          <button class="cancel" @click="hiddenDislog">取消</button>
          <button class="sure" @click="cancelOrder">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { payUrl, hostUrl } from '../http/env.js'
import _wx from '../../static/js/chelun-wx-1.1.js'
import URL from '../../static/js/url.js'
import cjjl from '../../static/js/chaojijiaolian-jl.js'
import { unpaidById, pushStudentOrder, cancelOrder } from '@/http/api'
export default {
  props: ['payOrder', 'openid'],
  data () {
    return {
      dialog: false,
      public_path: process.env.PUBLICK_PATH,
      paid: false,
      iswx: _wx.isWx
    }
  },
  methods: {
    showDislog () {
      this.dialog = true
    },

    hiddenDislog () {
      this.dialog = false
    },

    cancelOrder () {
      let id = this.payOrder.id
      let channel_uid = this.payOrder.channel_uid
      let channel_no = this.payOrder.channel_no
      cancelOrder({id: id, channel_no: channel_no, channel_uid: channel_uid}).then(res => {
        if (res.code === 0) {
          this.$router.back(-1)
        }
      })
    },
    pay () {
      let channel = _wx.isWx ? 'weixin_mp' : 'alipay'
      let callbackUrl = `${hostUrl}/agent/ecmall/paid`
      let url = `${payUrl}/api.php?c=order&v=pay2&serial_number=${this.payOrder.serialnumber}&channel=${channel}&openid=${this.openid}&callback_url=${callbackUrl}`
      console.log(url)
      axios.get(url).then(res => {
        console.log(res)
        if (_wx.isWx) {
          _wx.pay(res.data.data.order_param, function () {
            window.location.href = res.data.data.order_param.callback_url
          })
        } else {
          window.location.href = res.data.data.url
        }
      })
    },
  },
  mounted () {
    console.log(this.iswx)
  }
}
</script>

<style lang="scss" scoped>
.hint {
  margin-top: .7rem;
  text-align: center;
  span {
    font-weight: 600;
  }
  img {
    display: inline-block;
    vertical-align: middle;
    width: .47rem;
    height: .47rem;
  }
  span {
    font-size: .36rem;
    color: #02B389;
    display: inline-block;
    vertical-align: middle;
    margin-left: .2rem;
  }
}
.orderid {
  color: rgba(51, 51, 51, .4);
  margin-top: .16rem;
  text-align: center;
  font-size: .26rem;
}
.time {
  margin-top: .86rem;
  text-align: center;
  font-size: .26rem;
  line-height: 1.8;
  font-weight: 600;
  div:first-child {
    font-weight: 500;
    color: rgba(51, 51, 51, .5);
  }
}
.money {
  padding: 0 .3rem;
  height: 1rem;
  line-height: 1rem;
  border-bottom: 1px solid #EBEBEB;
  display: -webkit-flex;
  display: flex;
  .text {
    text-align: left;
    flex: 1;
    color: rgba(51, 51, 51, .5);
    font-size: .30rem;
  }
  .sum {
    float: right;
    font-size: .28rem;
    span {
      font-size: .42rem;
    }
  }
}
.way {
  padding: 0 .3rem;
  .title {
    font-size: .3rem;
    line-height: .88rem;
    font-weight: 600;
  }
  .channel {
    margin-top: .2rem;
    display: -webkit-flex;
    .name {
      flex: 1;
      text-align: left;
      img {
        width: .7rem;
        height: .7rem;
        display: inline-block;
        vertical-align: middle;
      }
      span {
        display: inline-block;
        font-size: .3rem;
        margin-left: .31rem;
        vertical-align: middle;
      }
    }
    .sel-img {
      text-align: right;
      flex: 1;
      img {
        width: .56rem;
        height: .56rem;
        display: inline-block;
        margin-top: .08rem;
      }
    }
  }
}
.pay-btn {
  display: block;
  width: 6.9rem;
  height: .90rem;
  line-height: .9rem;
  background: rgba(2, 179, 137, 1);
  border-radius: .45rem;
  color: #fff;
  font-size: .32rem;
  margin: 3rem auto auto;
}

.cancel-btn {
  display: block;
  width: 6.9rem;
  height: .90rem;
  line-height: .9rem;
  border-radius: .45rem;
  color: #fff;
  font-size: .32rem;
  background: none;
  margin: .3rem auto auto;
  color: #333;
  opacity: .8;
  border: 1px solid #02B389;
}

.bg {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  .dialog {
    position: absolute;
    width: 4rem;
    height: 2rem;
    padding-top: .4rem;
    box-sizing: border-box;
    background: #fff;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    .content {
      font-size: .30rem;
      text-align: center;
    }
  }
  .btn {
    border-top: 1px solid #eee;
    display: flex;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: .8rem;
    button {
      flex: 1;
      background: #fff;
    }
    .sure {
      color: #02B389;
      border-left: 1px solid #eee;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pay.vue